module.exports = __webpack_public_path__ + "static/media/logo.1dcc3b04.png";


//////////////////
// WEBPACK FOOTER
// ./src/logo.png
// module id = 188
// module chunks = 20